import { useEffect, useRef, useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { canShowPaymentAccount } from './paymentAccountEligibility';

export const PAYMENT_ACCOUNT_NUMBER = '8622327979';

export default function PaymentAccount({ data, pending = false }) {
    const [copyState, setCopyState] = useState('idle');
    const manualRef = useRef(null);
    const version = useRef(0);
    const eligible = canShowPaymentAccount(data, pending);
    useEffect(() => { version.current += 1; setCopyState('idle'); return () => { version.current += 1; }; }, [data, pending]);
    useEffect(() => { if (copyState === 'manual') { manualRef.current?.focus(); manualRef.current?.select(); } }, [copyState]);
    if (!eligible) return null;
    const copy = async () => {
        const request = version.current;
        try {
            if (typeof navigator.clipboard?.writeText !== 'function') throw new Error('clipboard-unavailable');
            await navigator.clipboard.writeText(PAYMENT_ACCOUNT_NUMBER);
            if (request === version.current) setCopyState('copied');
        } catch (_) {
            if (request === version.current) setCopyState('manual');
        }
    };
    return (
        <section data-testid="payment-account" aria-label="Rekening pembayaran" className="mt-2.5 rounded-xl border border-blue-100 bg-blue-50/50 px-3 py-2.5">
            <p className="text-[10px] uppercase tracking-wide font-semibold text-[color:var(--wx-muted)]">Rekening pembayaran</p>
            <div className="mt-1 flex items-center justify-between gap-2">
                <p className="text-base font-bold tracking-tight text-[color:var(--wx-ink)] select-text">BCA {PAYMENT_ACCOUNT_NUMBER}</p>
                <button type="button" onClick={copy} aria-label="Salin nomor rekening" className="inline-flex shrink-0 items-center gap-1 rounded-lg border border-blue-200 bg-white px-2 py-1.5 text-[11px] font-semibold text-[color:var(--wx-blue)]">
                    {copyState === 'copied' ? <Check className="w-3 h-3" aria-hidden="true" /> : <Copy className="w-3 h-3" aria-hidden="true" />}
                    {copyState === 'copied' ? 'Tersalin' : 'Salin'}
                </button>
            </div>
            <p className="mt-0.5 text-[10px] text-[color:var(--wx-muted)]">a.n. Wxfaous Adijaya Sentosa</p>
            <span role="status" className={copyState === 'manual' ? 'mt-2 block text-[10px] text-[color:var(--wx-muted)]' : 'sr-only'}>
                {copyState === 'copied' ? 'Nomor rekening tersalin.' : copyState === 'manual' ? 'Salin manual nomor berikut.' : ''}
            </span>
            {copyState === 'manual' && <input ref={manualRef} aria-label="Nomor rekening untuk disalin manual" readOnly value={PAYMENT_ACCOUNT_NUMBER} onFocus={event => event.target.select()} className="mt-1 w-full rounded border border-blue-200 bg-white px-2 py-1 text-xs text-[color:var(--wx-ink)]" />}
        </section>
    );
}
